import React, { useEffect } from 'react';
import { usePortal } from 'context';
import './streamsInfo.scss';

const StreamsInfo = () => {
    const {
        user: { username, viewReportUrl, partnerAccent },
        streamCount,
        fetchStreamCount,
    } = usePortal();

    useEffect(() => {
        fetchStreamCount(username);
    }, []);

    if (streamCount === -1 || streamCount === undefined) {
        return null;
    }

    return (
        <section className="subheader-item streams-info-container">
            <div className="streams-info">
                <h2 style={{ color: partnerAccent ? partnerAccent : undefined }}>{streamCount}</h2>
                <div className="stream-stack">
                    <div>{`Service${streamCount !== 1 ? 's' : ''} this month`}</div>

                    {viewReportUrl && (
                        <a href={viewReportUrl} target="_blank" rel="noopen noreferrer">
                            View Full Report
                        </a>
                    )}
                </div>
            </div>
        </section>
    );
};

export default StreamsInfo;
